import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_CANCELLATION_REASON,
  ADD_CANCELLATION_REASON,
  UPDATE_CANCELLATION_REASON,
  DELETE_CANCELLATION_REASON,
} from './actionTypes'
import {
  getCancellationReasonSuccess,
  getCancellationReasonFail,
  addCancellationReasonSuccess,
  addCancellationReasonFail,
  updateCancellationReasonSuccess,
  updateCancellationReasonFail,
  deleteCancellationReasonSuccess,
  deleteCancellationReasonFail,
  setCancellationReasonFieldErrors,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'

// API calls
const fetchCancellationReasonApi = () => axiosInstance.get('', { params: { sp: 'usp_GetCancellationReasons' } })
const addCancellationReasonApi = (cancellationReason) => axiosInstance.post('', cancellationReason)
const updateCancellationReasonApi = (cancellationReason) => axiosInstance.post('', cancellationReason)
const deleteCancellationReasonApi = (id) => axiosInstance.post('', { sp: 'usp_DeleteCancellationReason', cancellationReasonId: id })

// Sagas
function* getCancellationReasonSaga() {
  try {
    const { data } = yield call(fetchCancellationReasonApi)
    yield put(getCancellationReasonSuccess(data))
  } catch (error) {
    yield put(getCancellationReasonFail(error.response?.data || error.message))
    toast.error('Failed to fetch cancellation reasons!')
  }
}

function* addCancellationReasonSaga(action) {
  try {
    const { data } = yield call(addCancellationReasonApi, action.payload)
    yield put(addCancellationReasonSuccess(data))
    toast.success('Cancellation reason added successfully!')
    yield put({ type: GET_CANCELLATION_REASON })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setCancellationReasonFieldErrors(error.response.data.fieldErrors))
      toast.error('Please fix the highlighted errors.')
    } else {
      yield put(addCancellationReasonFail(error.response?.data || error.message))
      toast.error('Failed to add cancellation reason!')
    }
  }
}

function* updateCancellationReasonSaga(action) {
  try {
    const { data } = yield call(updateCancellationReasonApi, action.payload)
    yield put(updateCancellationReasonSuccess(data))
    toast.success('Cancellation reason updated successfully!')
    yield put({ type: GET_CANCELLATION_REASON })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setCancellationReasonFieldErrors(error.response.data.fieldErrors))
      toast.error('Please fix the highlighted errors.')
    } else {
      yield put(updateCancellationReasonFail(error.response?.data || error.message))
      toast.error('Failed to update cancellation reason!')
    }
  }
}

function* deleteCancellationReasonSaga(action) {
  try {
    yield call(deleteCancellationReasonApi, action.payload)
    yield put(deleteCancellationReasonSuccess(action.payload))
    toast.success('Cancellation reason deleted successfully!')
    yield put({ type: GET_CANCELLATION_REASON })
  } catch (error) {
    yield put(deleteCancellationReasonFail(error.response?.data || error.message))
    toast.error('Failed to delete cancellation reason!')
  }
}

// Watcher saga
function* cancellationReasonSaga() {
  yield takeEvery(GET_CANCELLATION_REASON, getCancellationReasonSaga)
  yield takeEvery(ADD_CANCELLATION_REASON, addCancellationReasonSaga)
  yield takeEvery(UPDATE_CANCELLATION_REASON, updateCancellationReasonSaga)
  yield takeEvery(DELETE_CANCELLATION_REASON, deleteCancellationReasonSaga)
}

export default cancellationReasonSaga
